import { combineReducers } from "@reduxjs/toolkit";
import estimatedCalculation from "./estimated-calculation";

const estimatedCalculationReducer = combineReducers({
  estimatedCalculation,
});

export default estimatedCalculationReducer;
